import React, { useEffect, useState } from 'react'

const defaultServices = [
  {
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    title: 'Fast and Free Shipping on all United States',
    subtitle: 'International shipping Flat Fee 1 LBS',
  },
  {
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10" />
      </svg>
    ),
    title: 'Quality Parts',
    subtitle: 'Huge range of parts',
  },
  {
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3H14z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3" />
      </svg>
    ),
    title: 'Easy & Free Returns',
    subtitle: 'All shipping methods',
  },
  // {
  //   icon: (
  //     <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth="1.8">
  //       <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  //     </svg>
  //   ),
  //   title: 'Expert Customer Service',
  //   subtitle: 'Choose chat or call us',
  // },
  {
    icon: (
      <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
    title: 'Wishlist',
    subtitle: 'Wishlist your favorite products',
  },
]

function serviceIcon(icon, index = 0) {
  const resolvedIcon = icon || ["map", "package", "returns", "wishlist"][index] || "map";
  if (icon && typeof icon !== "string") return icon;

  const commonProps = { width: "28", height: "28", fill: "none", viewBox: "0 0 24 24", stroke: "#fff", strokeWidth: "1.8" };
  if (resolvedIcon === "package") {
    return (
      <svg {...commonProps}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10" />
      </svg>
    );
  }
  if (resolvedIcon === "returns") {
    return (
      <svg {...commonProps}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3H14z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3" />
      </svg>
    );
  }
  if (resolvedIcon === "wishlist") {
    return (
      <svg {...commonProps}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    );
  }
  return (
    <svg {...commonProps}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  );
}

function Services({ services = defaultServices }) {
  const [visible, setVisible] = useState(false)
  const [itemsVisible, setItemsVisible] = useState([])

  useEffect(() => {
    setVisible(false)
    setItemsVisible([])

    // Bar slides in first
    const barTimer = setTimeout(() => setVisible(true), 100)
    const itemTimers = []

    // Then each item fades in one by one
    services.forEach((_, i) => {
      itemTimers.push(setTimeout(() => {
        setItemsVisible(prev => [...prev, i])
      }, 400 + i * 120))
    })

    return () => {
      clearTimeout(barTimer)
      itemTimers.forEach(clearTimeout)
    }
  }, [services])

  return (
    <>
      <style>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-24px) scaleX(0.85); }
          to   { opacity: 1; transform: translateY(0)     scaleX(1); }
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(10px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes iconPop {
          0%   { transform: scale(0.4) rotate(-15deg); opacity: 0; }
          70%  { transform: scale(1.15) rotate(4deg); opacity: 1; }
          100% { transform: scale(1) rotate(0deg); opacity: 1; }
        }
        .services-bar {
          background: #1a6db5;
          border-radius: 50px;
          padding: 25px 32px;
          margin: 20px auto;
          // max-width: 1200px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          opacity: 0;
          transform: translateY(-24px) scaleX(0.85);
          transition: none;
        }
        .services-bar.visible {
          animation: slideDown 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }
        .service-item {
          display: flex;
          align-items: center;
          gap: 10px;
          flex: auto;
          padding: 0 12px;
          justify-content: start;
          opacity: 0;
        }
        .service-item.visible {
          animation: fadeUp 0.45s cubic-bezier(0.22, 1, 0.36, 1) forwards;
        }
        .service-icon {
          flex-shrink: 0;
          opacity: 0;
        }
        .service-icon.visible {
          animation: iconPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }
        .service-divider {
          width: 1px;
          height: 0px;
          background: rgba(255,255,255,0.35);
          flex-shrink: 0;
          transition: height 0.4s ease;
        }
        .service-divider.visible {
          height: 32px;
        }
      `}</style>

  <div className="container">
        <div className={`services-bar${visible ? ' visible' : ''}`}>
        {services.map((service, index) => (
          <React.Fragment key={index}>
            <div className={`service-item${itemsVisible.includes(index) ? ' visible' : ''}`}>
              <div
                className={`service-icon${itemsVisible.includes(index) ? ' visible' : ''}`}
                style={{ animationDelay: `${index * 0.06}s` }}
              >
                {serviceIcon(service.icon, index)}
              </div>
              <div>
                <p style={{
                  margin: 0,
                  fontFamily: '"Outfit", sans-serif',
                  fontWeight: 700,
                  fontSize: '14px',
                  color: '#fff',
                  whiteSpace: 'nowrap',
                }}>
                  {service.title}
                </p>
                <p style={{
                  margin: 0,
                  fontFamily: '"Outfit", sans-serif',
                  fontWeight: 400,
                  fontSize: '12px',
                  color: 'rgba(255,255,255,0.85)',
                  whiteSpace: 'nowrap',
                }}>
                  {service.subtitle}
                </p>
              </div>
            </div>

            {index < services.length - 1 && (
              <div className={`service-divider${visible ? ' visible' : ''}`}
                style={{ transitionDelay: `${0.3 + index * 0.1}s` }}
              />
            )}
          </React.Fragment>
        ))}
      </div>
  </div>
    </>
  )
}

export default Services
